<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">

      <!-- <input type="date" id="start" name="trip-start"
       value="2018-07-22"
       min="2018-01-01" max="2018-12-31"> -->

      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Crear Simulacros</h1>

      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div class="card-body">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <div class="row">
              <div class="col-6">
                <b-form-group label="Título" label-for="keyInput">
                  <b-form-input
                    id="keyInput"
                    v-model="form.title"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Key" label-for="keyInput">
                  <b-form-input
                    id="keyInput"
                    v-model="form.key"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Inicio de fecha" label-for="keyInput">
                  <date-pick
                  class="endDate2"
                  v-model="form.startDate"
                  :pickTime="true"
                  :format="'YYYY-MM-DD HH:mm'"
                ></date-pick>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Fin de fecha" label-for="keyInput">
                  <date-pick
                  class="endDate2"
                  v-model="form.endDate"
                  :pickTime="true"
                  :format="'YYYY-MM-DD HH:mm'"
                ></date-pick>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Mínimo de preguntas" label-for="keyInput">
                  <b-form-input
                    id="keyInput"
                    v-model="form.minQuestions"
                    @input="handleInputChange"
                    required
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Máximo de preguntas" label-for="keyInput">
                  <b-form-input
                    id="keyInput"
                    v-model="form.maxQuestions"
                    required
                    @input="handleInputChange"
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group label="Duración (en minutos)" label-for="keyInput">
                  <b-form-input id="keyInput" v-model="form.duration" required type="number"  @input="handleInputChange()"></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <input
                  type="checkbox"
                  v-model="form.isPremium"
                  :class="{ 'checked': form.isPremium }"
                />
                <span class="span-diagnostic">Es simulacro premium</span>
              </div>

            </div>
            <b-button type="submit" variant="primary" @click="verifyDate(this.endDate)" >Guardar</b-button>
            <b-button type="submit" variant="primary" class="float-right" @click="goToSimulacrums">Cancelar</b-button>
          </b-form>
        </div>
      </div>
    </div>

    <!-- add Questions-->
    <div class="container-fluid" v-if="isEdit">
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div id="app" class="container">
          <div class="div-lessons">
            <h3>Preguntas:</h3>
            <div>
              <button class="btn btn-primary" @click="showModal()">
                <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Preguntas
              </button>
              <button class="btn btn-primary ml-2" @click="showModalAddQuestionsRandom()">
                <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Preguntas Aleatoriamente
              </button>
            </div>
          </div>

          <br>
          <br>

          <table class="table">
            <thead>
              <tr >
                <th>Nombre unico</th>
              </tr>
            </thead>

            <tbody v-for="question in simulacrumsQuestions.questions" :key="question.id">
              <tr >
                <td>{{question.uniqueName}}</td>
                <td></td>
                <td>
                  <button class="btn btn-secondary p-2 d-block w-100 ml-2"
                  v-on:click="deleteQuestion(question.id)">
                        Eliminar
                  </button>
                </td>
              </tr>
            </tbody>

            <tbody >
              <tr >
                <td colspan="2" class="td-nhd">No hay datos</td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>

      <QuestionAdd ref="quesionAddComponent" @saveQuestion="saveQuestion"/>
      <QuestionsAddRandom ref="quesionAddRandomComponent" :parent-model="module"/>

    </div>
     <!-- /add Questions-->

  </div>
</template>

<script>
import axios from "axios";
import router from "../../../../router";

import 'vue-date-pick/dist/vueDatePick.css';
import DatePick from 'vue-date-pick';
import QuestionAdd from "../Questions/QuestionsAdd.vue";
import QuestionsAddRandom from "../Questions/QuestionsAddRandom.vue"


export default {
  components: { QuestionAdd, DatePick, QuestionsAddRandom},
  data() {
    return {
      form: {
        duration: "",
        endDate: "",
        key: "",
        maxQuestions: "",
        minQuestions: "",
        startDate: "",
        title: "",
        moduleId: "",
        isPremium: false,
      },
      modules: [],
      modulesResponse: [],
      practiceId: null,
      show: true,
      simulacrumId: null,
      isEdit: false,
      inputDaterange: null,
      searchQuestions: "",
      lessonsQuestions: [],
      simulacrumsQuestions: [],
      module: 'simulacrums',
    };
  },
  methods: {
    handleInputChange() {
      if (this.form.maxQuestions < 0) {
        this.form.maxQuestions = Math.abs(this.form.maxQuestions);
      }
      if (this.form.minQuestions < 0) {
        this.form.minQuestions = Math.abs(this.form.minQuestions);
      }
      if (this.form.duration < 0) {
        this.form.duration = Math.abs(this.form.duration);
      }
    },
    showModal() {
      this.$refs['quesionAddComponent'].showModal();
    },
    showModalAddQuestionsRandom() {
      this.$refs['quesionAddRandomComponent'].showModal();
    },
    onModalHide() {
      this.searchQuestions= '';
      this.lessonsQuestions= '';
    },
    deleteQuestion(id) {
      if(!confirm("¿Estás seguro que deseas eliminar esta pregunta?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/" + this.simulacrumId + "/questions/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    saveQuestion(questionId) {

      // this.practiceId = this.$route.params.id;
      // var practiceId = parseInt(this.practiceId);
      this.simulacrumId = this.$route.params.id;
      var simulacrumId = parseInt(this.simulacrumId);
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/saveQuestion", {
        'simulacrumId': simulacrumId  , 'questionId': questionId
      }, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then((result) => {
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.s(
            "Pregunta Guardado."
        );
        console.log(result);
        this.$router.go();
      }).catch((err) => {
        if (err.response.data === 'duplicated') {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
             "Error al crear, Ya se ha agregado esta pregunta antes"
          );
          console.log(err.message);
        }else if (err.response.data === 'maxReached') {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
              "Maximo de preguntas alcanzado"
          );
          console.log(err.message);
        } else {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Error al crear"
          );
          console.log(err.message);
        }
      });
    },
    loadSimulacrum(){
      if (this.$route.params.id) {
        let loader = this.$loading.show({});
        this.simulacrumId = this.$route.params.id;
        this.isEdit = true;
        axios
          .get(
            import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/" + this.simulacrumId,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            this.form.active = response.data.active;
            this.form.duration = response.data.duration;
            this.form.endDate = response.data.endDate.replace("T", " ").slice(0, -3);
            this.form.key = response.data.key;
            this.form.maxQuestions = response.data.maxQuestions;
            this.form.minQuestions = response.data.minQuestions;
            this.form.startDate = response.data.startDate.replace("T", " ").slice(0, -3);
            this.form.title = response.data.title;
            this.form.moduleId = response.data.module;
            this.form.isPremium = response.data.isPremium || false;
            if(response.data === '') {
              console.log(response.data)
              this.simulacrumsQuestions = [];
              return;
            }
            this.simulacrumsQuestions = response.data
            loader.hide();
          })
          .catch((err) => {
            console.log(err.message);
            loader.hide();
          });
      }
    },

    goToSimulacrums() {
      this.$router.push(`/admin-panel/simulacrums`);
    },
    onSubmit(event) {
      event.preventDefault();
      if (!this.form.endDate || !this.form.startDate) {
        this.$toastr.error("Falta el campo de fecha de inicio o fecha  fin" );
        return;
      }

      // Normalizar isPremium para asegurar que sea boolean
      this.form.isPremium = this.form.isPremium === true || this.form.isPremium === 'true';

      let loader = this.$loading.show({});

      if (this.form.endDate == "" || this.form.startDate == ""){
        alert("por favor ingrese un rango de fecha");
        loader.hide();
      } else {
        if (this.isEdit) {
        axios
          .put(
            import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/edit/" + this.simulacrumId, this.form,{
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          )
          .then((result) => {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.s("Simulacro Editado.");
            console.log(result);
            loader.hide();
            router.push({ path: `/admin-panel/simulacrums` });
          }).catch((err) => {
            if (err.response.data.response === 'duplicated') {
              this.$toastr.defaultTimeout = 2000; // default timeout : 5000
              this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
              this.$toastr.e(
                "Ya se ha creado un simulacro con este nombre"
              );
              console.log(err.message);
              loader.hide();
            } else {
              this.$toastr.defaultTimeout = 2000; // default timeout : 5000
              this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
              this.$toastr.e(
                "Error al editar"
              );
              console.log(err.message);
              loader.hide();
            }
          });
      } else {
        axios
          .post(
            import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/save",this.form,{
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.s("Curso Guardado.");
            console.log(result);
            loader.hide();
            router.push({ path: `/admin-panel/simulacrums` });
          }).catch((err) => {
            if (err.response.data.response === 'duplicated') {
              this.$toastr.defaultTimeout = 2000; // default timeout : 5000
              this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
              this.$toastr.e(
                "Ya se ha creado un simulacro con este nombre"
              );
              console.log(err.message);
              loader.hide();
            } else {
              this.$toastr.defaultTimeout = 2000; // default timeout : 5000
              this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
              this.$toastr.e(
                "Error al crear"
              );
              console.log(err.message);
              loader.hide();
            }
          });
        }
      }
    },
    onReset(event) {
      event.preventDefault();
    },
  },
  mounted() {
    this.loadSimulacrum();
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();

    window.MathJax.Hub.Config({
      tex2jax: {
        inlineMath: [
          ["$", "$"],
          ["\\(", "\\)"],
        ],
      },
    });
  },
};
</script>
